module.exports = __webpack_public_path__ + "static/media/gmn_logo.9d589aae.png";